import { Injectable } from '@angular/core';

export class StatusMessage {
  message:string;
  state:string; //loading or warning
}

@Injectable({
  providedIn: 'root'
})
export class StatusBarService {

  statusMessage:StatusMessage;

  constructor() {}

  statusLoading(message:string):StatusMessage{
    return {message:message,state:"loading"}
  }

  statusWarning(message:string):StatusMessage{
    return {message:message,state:"warning"}
  }

  statusInfo(message:string):StatusMessage{
    return {message:message,state:"info"}
  }

  clear():StatusMessage{
    return {message:"",state:""};
  }

}
